import React from "react";
import { tabStyles as styles } from "./tabs.tailwind";

// Tab
const Tab = ({ tab, isActive, onClick }) => {
  return (
    <button
      className={`${styles.button} ${isActive ? styles.activeTab : ""}`}
      onClick={onClick}
    >
      {tab?.tabName}
    </button>
  );
};

export default Tab;
